import "d3-transition";
import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import { select } from "d3-selection";

import "./d3Chart.css";
//import { setbubble, setclearAll } from "../../../../redux/actions/DisplayChart";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllFilters,
  getAllShareFilters,
  getBrands,
  getCustomizedDate,
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
  useQuery,
} from "../../../../redux/constants";
import moment from "moment";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
  set_WM_DeepDive,
} from "../../../../redux/actions/WidgetMaker/WidgetMaker";
import {
  setisDeepDive,
  setSelectedDeepdiveWidget,
} from "../../../../redux/actions/dashboard/Tab1";
import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setMentionPageData,
  setTabClick,
} from "../../../../redux/actions/DeepDive";
import { getDeepDive } from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import { Tooltip } from "antd";
import { setShareSelectedDeepdiveWidget } from "../../../../redux/actions/share/Share";

const BubbleChart = (props) => {
  let query = useQuery();

  const mainDivRef = useRef(null);
  const DivRef = useRef();
  const headeRef = useRef(null);
  const {
    single,
    uniqueId,
    splitcolumns,
    style,
    isdownload,
    splitcolumncount,
    legend_position,
    show_legend,
    section_index,
    widget_index,
    PdfDownloadStatus,
  } = props;

  const [bubbleData, setbubbleData] = useState(null);
  const [tooltipPie, setTooltipPie] = useState(null);
  const [tooltiphead, setTooltiphead] = useState(null);
  const [width, setWidth] = useState(window?.innerWidth - 80);
  const [legend, setlegend] = useState(null);
  const [bubbleTextTooltip, setBubbleTextTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: "",
  });
  const dispatch = useDispatch();
  const splitObj = useSelector((state) => state.Welcome.graphDetail.split);
  //const bubbleRef = useSelector((state) => state.Filter.bubbleRef);
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const footerValue = useSelector((state) => state.Section.footerValue);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall?.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall?.shareableLinkDeepDiveStatus
  );
  const shareCategory = useSelector((state) => state.ApiCall?.shareCategory);
  const sharedDuration = useSelector((state) => state.Share?.sharedDuration);
  const shareBrands = useSelector((state) => state.ApiCall?.shareBrands);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  const height =
    isdownload === true && !PdfDownloadStatus
      ? 230
      : style && style?.height
      ? Number(String(style?.height).replace("px", "")) - 50
      : 450;
  useEffect(() => {
    if (isWidgetEdit) {
      if (mainDivRef?.current?.clientWidth) {
        setWidth(mainDivRef?.current?.clientWidth);
      } else {
        const edtwidth = window?.innerWidth / 2 - 80;
        const edinew = edtwidth - edtwidth / 4;
        setWidth(edinew - 10);
        bubbleData && createBubbleChart(edinew - 10);
      }
      bubbleData && window.addEventListener("resize", createBubbleChart);
    } else if (isdownload === true && splitcolumncount === 2) {
      setWidth(530);
    } else if (isdownload === true && splitcolumncount === 3) {
      setWidth(350);
    } else if (isdownload === true) {
      setWidth(500);
    } else if (splitcolumncount === 2) {
      if (mainDivRef?.current?.clientWidth) {
        setWidth(mainDivRef?.current?.clientWidth);
      } else {
        setWidth(530);
      }
    } else if (splitcolumncount === 3) {
      if (mainDivRef?.current?.clientWidth) {
        setWidth(mainDivRef?.current?.clientWidth);
      } else {
        setWidth(350);
      }
    } else {
      if (splitObj && splitObj?.columns?.length === 2) {
        setWidth(window?.innerWidth / 2 - 80);
        bubbleData && createBubbleChart(window?.innerWidth / 2 - 80);
        bubbleData && window?.addEventListener("resize", createBubbleChart);
      } else if (splitObj && splitObj?.columns?.length === 3) {
        setWidth(window?.innerWidth / 3 - 80);
        bubbleData && createBubbleChart(window?.innerWidth / 3 - 80);
        bubbleData && window?.addEventListener("resize", createBubbleChart);
      } else if (splitcolumns && splitcolumns === 2) {
        if (mainDivRef?.current?.clientWidth) {
          setWidth(mainDivRef?.current?.clientWidth);
          bubbleData && createBubbleChart(mainDivRef?.current?.clientWidth);
        } else {
          setWidth(window?.innerWidth / 2 - 80);
          bubbleData && createBubbleChart(window?.innerWidth / 2 - 80);
        }
        bubbleData && window?.addEventListener("resize", createBubbleChart);
      } else if (splitcolumns && splitcolumns === 3) {
        if (mainDivRef?.current?.clientWidth) {
          setWidth(mainDivRef?.current?.clientWidth);
          bubbleData && createBubbleChart(mainDivRef?.current?.clientWidth);
        } else {
          setWidth(window?.innerWidth / 3 - 80);
          bubbleData && createBubbleChart(window?.innerWidth / 3 - 80);
        }
        bubbleData && window?.addEventListener("resize", createBubbleChart);
      } else {
        if (legend_position === "left" || legend_position === "right") {
          setWidth(window?.innerWidth / 2 - 260);
          bubbleData && createBubbleChart(window?.innerWidth / 2 - 260);
          bubbleData && window?.addEventListener("resize", createBubbleChart);
        } else {
          setWidth(window?.innerWidth / 2 - 80);
          bubbleData && createBubbleChart(window?.innerWidth / 2 - 80);
          bubbleData && window?.addEventListener("resize", createBubbleChart);
        }
      }
    }
  }, [width, isWidgetEdit, legend_position]);

  useEffect(() => {
    const arr = [];

    if (single) {
      let a = single[0]?.names;
      let b = single[0]?.pie_sizes;
      let c = single[0]?.size;
      let d = single[0]?.colors;
      let e = single[0]?.pie_names;

      let legendArr = [];
      let finalLegendArr = [];
      for (let i = 0; i < single[0]?.names?.length; i++) {
        arr.push([a[i], b[i], [c[i]], d && d[i], e[i]]);
        single[0]?.pie_names[i]?.forEach((el, j) => {
          if (!legendArr?.includes(el)) {
            legendArr?.push(el);
            finalLegendArr?.push({
              legend: el,
              color: single[0]?.colors[i][j],
            });
          }
        });
      }

      setlegend(finalLegendArr);
      setbubbleData(arr);
    }
  }, [single]);

  //  const outerRadius = data.map(d => d[2]);
  //  const outerNew = outerRadius.map(d => d)

  var arc = d3?.arc()?.innerRadius(0)?.outerRadius(50);

  // d3 pie object
  var arcGenerator = d3
    ?.pie()
    ?.padAngle(0)
    ?.value((d) => d);
  //var color = d3.schemeCategory10;

  // const onBubbleClick = (event) => {
  //   let obj;
  //   obj = {
  //     x: tooltipPie?.data[0],
  //     y: event.name,
  //     split: compare_key ? compare_key : null,
  //   };
  //   obj && !deepDive && dispatch(setbubble(obj)); //set bar values
  //   !deepDive && dispatch(setclearAll("bubble")); //clear all charts state except "bar"
  // };

  const makeHierarchy = (data) => {
    return d3?.hierarchy({ children: data }).sum((d) => {
      return d[2];
    });
  };
  const pack = (size) => {
    return d3?.pack()?.size(size)?.padding(2);
  };

  useEffect(() => {
    bubbleData && createBubbleChart();
    bubbleData && window?.addEventListener("resize", createBubbleChart);
    return () => window?.removeEventListener("resize", createBubbleChart);
  }, [bubbleData]);

  const createBubbleChart = (width1) => {
    d3?.selectAll(
      `#bubblechart__${uniqueId?.replaceAll(/[^a-zA-Z0-9]/g, "")} g`
    )?.remove();
    let hierachalData = makeHierarchy(bubbleData);
    let packLayout = pack([
      width1 > 0 ? width1 : width > 0 ? width : 560,
      height,
    ]);
    const root = packLayout(hierachalData);
    const tooltip = d3?.select(
      `#newtooltip__${uniqueId?.replaceAll(/[^a-zA-Z0-9]/g, "")}`
    );
    //var zoom = zoom;

    var points = select(DivRef.current)
      ?.selectAll("g")
      ?.data(root.leaves())
      ?.enter()
      ?.append("g")
      ?.attr("font-size", (d) => {
        return d.r / 5;
      })
      ?.style("fill", authParams?.theme_type === "1" ? "#b1bdd0" : "#3B5175")
      ?.attr("font-family", "Roboto Slab")
      ?.attr("text-anchor", "middle")
      ?.attr("font-weight", "500")
      // .attr("transform", d => `translate(${d.x * 1.5},${d.y})`)
      ?.attr("transform", `translate(${width / 2}, ${height / 2})`)
      //.attr("transform", "translate(#{margin.left},#{margin.top})")
      ?.attr("class", "node");

    var pies = points?.selectAll(".node")?.data(function (d) {
      return arcGenerator(d?.data[1])?.map((m, i) => {
        m.r = d?.r;
        m.x = d?.x;
        m.y = d?.y;
        let obj = {
          data: m,
          color: d?.data[3] && d?.data[3][i],
          name: d?.data[4][i],
        };
        return obj;
      });
    });
    var arcEnter = pies?.enter()?.append("g")?.attr("class", "arc");
    arcEnter
      ?.append("path")
      ?.attr("d", function (d) {
        arc?.outerRadius(d?.data?.r);
        return arc(d?.data);
      })
      ?.style("opacity", "0.6")
      ?.style("cursor", "pointer")
      ?.style("stroke", "#eee")
      ?.attr("fill", function (d) {
        return d?.color;
      })
      ?.on("mouseover", function () {
        select(this)?.transition()?.duration("300")?.style("opacity", "0.7");
      })

      ?.on("mouseout", function () {
        select(this)?.transition()?.duration("500")?.style("opacity", "0.6");
      });

    points?.on("click", (e, d) => {
      if (
        ((window.location.pathname?.split("/")?.[1] === "dashboard" ||
          window.location.pathname?.split("/")?.[1] === "pin-dashboard") &&
          !PdfDownloadStatus &&
          e?.target?.__data__?.data?.index !== undefined) ||
        (shareableLinkDeepDiveStatus &&
          !PdfDownloadStatus &&
          e?.target?.__data__?.data?.index !== undefined)
      ) {
        let pathName = getWindowLocationPath()?.toLowerCase();
        let shareSections = shareTemplateData?.section
          ? shareTemplateData?.section?.[0]
          : shareTemplateData?.sections?.[section_index];

        let index = getPaneIndex(panes, activeKey);

        let widget_metadata = shareBrands
          ? shareSections?.widgets?.[widget_index]
          : section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

        let section_metadata = shareBrands
          ? shareSections
          : section_index >= 0
          ? panes?.[index]?.sections?.[section_index]
          : panes?.[index]?.section?.[0];

        let widget_ids = widget_metadata?.deep_dive_id
          ? widget_metadata?.deep_dive_id
          : workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
          ? ["info-bar", "2.1", "2.2", "2.3", "2.4"]
          : ["info-bar", "1.1", "1.2"];
        let Section_is_locked = section_metadata?.is_locked;
        let widgets_is_locked = widget_metadata?.is_locked;
        let twoMonthsDuration = getCustomizedDate(6, "Days");
        let defaultDuration = {
          from:
            moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.startTime,
          to:
            moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.endTime,
        };

        let global_duration = shareBrands
          ? sharedDuration?.from
            ? {
                from: sharedDuration?.from,
                to: sharedDuration?.to,
              }
            : null
          : panes?.[index]?.duration;
        let global_brands = shareBrands
          ? shareBrands
          : panes?.[index]?.brands
          ? panes?.[index]?.brands
          : null;
        let brandIds = shareBrands
          ? widget_metadata?.brand_ids
          : section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets &&
            panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.brand_ids
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_ids
          ? panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_ids
          : null;
        let sectionDateFilter = shareTemplateData?.sections
          ? {
              from: shareTemplateData?.sections?.[section_index]?.start_date
                ? shareTemplateData?.sections?.[section_index]?.start_date
                : null,
              to: shareTemplateData?.sections?.[section_index]?.end_date
                ? shareTemplateData?.sections?.[section_index]?.end_date
                : null,
            }
          : null;
        let widgetFilterDate = {
          from: widget_metadata?.start_date
            ? widget_metadata?.start_date
            : null,
          to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
        };

        let combinedFilters = [];
        if (!widget_metadata?.is_locked) {
          if (widgetFilterDate?.from)
            combinedFilters.push({
              attribute: "CreatedDate",
              type: "datetime",
              columns: widgetFilterDate,
            });

          if (sectionDateFilter?.from && !section_metadata?.is_locked) {
            combinedFilters.push({
              attribute: "CreatedDate",
              type: "datetime",
              columns: sectionDateFilter,
            });
          }
          if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
            let brandsForFilter = shareBrands
              ? getBrands(
                  shareBrands?.brand_groups,
                  section_metadata?.brand_ids,
                  shareBrands?.brand_list,
                  section_metadata?.brand_groups
                )
              : getBrands(
                  brandlogicalgroup,
                  section_metadata?.brand_ids,
                  brands,
                  section_metadata?.brand_groups
                );

            combinedFilters.push(brandsForFilter);
          }
          if (widget_metadata?.brand_ids) {
            let brandsForFilter = shareBrands
              ? getBrands(
                  shareBrands?.brand_groups,
                  widget_metadata?.brand_ids,
                  shareBrands?.brand_list,
                  widget_metadata?.brand_groups
                )
              : getBrands(
                  brandlogicalgroup,
                  widget_metadata?.brand_ids,
                  brands,
                  widget_metadata?.brand_groups
                );

            combinedFilters.push(brandsForFilter);
          }
        }

        if (widget_metadata?.filters)
          combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
        if (section_metadata?.filters)
          combinedFilters = [...section_metadata?.filters, ...combinedFilters];

        let filterData = combinedFilters?.filter((d) => d);
        let hidden_filter = shareTemplateData?.hidden_filter
          ? [shareTemplateData?.hidden_filter]
          : [];
        let quick_filter = shareTemplateData?.quick_filter
          ? [shareTemplateData?.quick_filter]
          : [];

        let filter = shareBrands
          ? getAllShareFilters(
              graphConditionConfig,
              shareTemplateData,
              section_index,
              widget_index,
              shareBrands
            )
          : getAllFilters(
              graphConditionConfig,
              panes,
              index,
              section_index,
              widget_index,
              brandlogicalgroup,
              brandIds
            );
        let widget_brands = shareBrands
          ? getBrands(
              shareBrands?.brand_groups,
              widget_metadata?.brand_ids,
              shareBrands?.brand_list,
              widget_metadata?.brand_groups
            )
          : getBrands(
              brandlogicalgroup,
              widget_metadata?.brand_ids,
              brands,
              widget_metadata?.brand_groups
            );
        let section_brands = shareBrands
          ? getBrands(
              shareBrands?.brand_groups,
              section_metadata?.brand_ids,
              shareBrands?.brand_list,
              section_metadata?.brand_groups
            )
          : getBrands(
              brandlogicalgroup,
              section_metadata?.brand_ids,
              brands,
              section_metadata?.brand_groups
            );

        let defaultBrands = shareBrands ? shareBrands : null;

        let sectionComprtitorBrandType =
          section_metadata?.comp_brand_type === false ||
          section_metadata?.comp_brand_type === true
            ? section_metadata?.comp_brand_type
            : null;
        let sectionComprtitorBrandTypeExists =
          sectionComprtitorBrandType === false ||
          sectionComprtitorBrandType === true;
        let globalBrandChangeInShare = false;
        let updatedComBrandList = [];
        if (
          !(Section_is_locked && section_brands?.columns?.length) &&
          sectionComprtitorBrandTypeExists
        ) {
          if (shareBrands) {
            let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
              ? defaultBrands?.brands?.columns?.[0]
              : defaultBrands?.brands?.[0]?.competitor
              ? defaultBrands?.brands?.[0]
              : defaultBrands?.brands?.competitor
              ? defaultBrands?.brands
              : null;
            let comBrandExists = comBrand?.competitor
              ? true
              : defaultBrands
              ? defaultBrands?.selected_brand_ids?.length &&
                defaultBrands?.selected_comp_brand_ids?.length > 0
              : null;
            if (comBrandExists) {
              if (comBrand) {
                if (sectionComprtitorBrandType === false) {
                  updatedComBrandList.push({
                    brand_id: comBrand?.name,
                    brand_name: comBrand?.brand_name,
                    brand_friendly_name: comBrand?.brand_friendly_name,
                  });
                } else {
                  comBrand?.competitorList?.forEach((competitorBrand) => {
                    updatedComBrandList.push(competitorBrand);
                  });
                }
                globalBrandChangeInShare = true;
              } else {
                if (sectionComprtitorBrandType === false) {
                  let parentB = defaultBrands?.selected_brand_ids?.[0];
                  updatedComBrandList.push({
                    brand_id: parentB?.brand_id,
                    brand_name: parentB?.brand_name,
                    brand_friendly_name: parentB?.brand_friendly_name,
                  });
                } else {
                  defaultBrands?.selected_comp_brand_ids?.forEach(
                    (competitorBrand) => {
                      updatedComBrandList.push(competitorBrand);
                    }
                  );
                }
              }
            } else {
              sectionComprtitorBrandTypeExists = false;
            }
          } else {
            let comBrand = global_brands?.columns?.[0]?.competitor
              ? global_brands?.columns?.[0]
              : global_brands?.[0]?.competitor
              ? global_brands?.[0]
              : global_brands?.competitor
              ? global_brands
              : null;
            if (comBrand?.competitor) {
              if (sectionComprtitorBrandType === false) {
                updatedComBrandList.push({
                  brand_id: comBrand?.name,
                  brand_name: comBrand?.brand_name,
                  brand_friendly_name: comBrand?.brand_friendly_name,
                });
              } else {
                comBrand?.competitorList?.forEach((competitorBrand) => {
                  updatedComBrandList.push(competitorBrand);
                });
              }
            } else {
              sectionComprtitorBrandTypeExists = false;
            }
          }
        }
        // here calculating the public_engagement_only for the deepdive
        let public_engagement_only =
          pathName === "CommandCenter"?.toLowerCase()
            ? false // for now static false sending for command center
            : shareBrands
            ? shareTemplateData?.template_type === "competition"
              ? shareTemplateData?.public_engagement_only || false
              : false
            : panes?.[index]?.template_type === "competition"
            ? panes?.[index]?.public_engagement_only || false
            : false;
        let graphObject = {
          start_date:
            widgets_is_locked && widget_metadata?.start_date
              ? widget_metadata?.start_date
              : Section_is_locked && section_metadata?.start_date
              ? section_metadata?.start_date
              : global_duration?.from
              ? global_duration?.from
              : defaultDuration?.from,
          end_date:
            widgets_is_locked && widget_metadata?.end_date
              ? widget_metadata?.end_date
              : Section_is_locked && section_metadata?.end_date
              ? section_metadata?.end_date
              : global_duration?.to
              ? global_duration?.to
              : defaultDuration?.to,
          brands: shareBrands
            ? widget_metadata?.is_locked && widget_brands?.columns
              ? widget_brands?.columns
                ? widget_brands?.columns
                : section_metadata?.is_locked
                ? section_brands?.columns
                  ? section_brands?.columns
                  : widget_metadata?.duplicate_for_brands
                  ? widget_metadata?.com_brand_ids
                  : sectionComprtitorBrandTypeExists
                  ? updatedComBrandList
                  : defaultBrands
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widgets_is_locked
            ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
              ? widget_brands?.columns
              : Section_is_locked
              ? section_metadata?.brand_ids || section_metadata?.brand_groups
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : global_brands
                ? global_brands
                : brandlogicalgroup?.length > 0
                ? brandlogicalgroup
                : brands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : Section_is_locked
            ? section_metadata?.brand_ids || section_metadata?.brand_groups
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands,
          isBrandModified:
            (widgets_is_locked || Section_is_locked) &&
            (section_metadata?.brand_ids ||
              section_metadata?.brand_groups ||
              widget_metadata?.brand_ids ||
              widget_metadata?.brand_groups)
              ? true
              : global_brands
              ? true
              : false,
          deepdive_on: {
            x_axis:
              (widget_metadata?.x_axis?.attribute ||
                widget_metadata?.primary) &&
              shareTemplateData
                ? {
                    date_part:
                      widget_metadata?.x_axis?.date_part &&
                      widget_metadata?.x_axis?.date_part !== "D"
                        ? widget_metadata?.x_axis?.date_part
                        : widget_metadata?.x_axis?.date_aggregation,
                    special_cases:
                      widget_metadata?.x_axis?.special_cases ||
                      widget_metadata?.special_cases,
                    attribute: widget_metadata?.x_axis?.attribute
                      ? widget_metadata?.x_axis?.attribute
                      : widget_metadata?.primary,
                    value: d?.data?.[0],
                    trace_name:
                      widget_metadata?.x_axis?.trace_name ||
                      allAttributes?.[
                        widget_metadata?.x_axis?.attribute
                          ? widget_metadata?.x_axis?.attribute
                          : widget_metadata?.primary
                      ]
                        ? widget_metadata?.x_axis?.trace_name ||
                          allAttributes?.[
                            widget_metadata?.x_axis?.attribute
                              ? widget_metadata?.x_axis?.attribute
                              : widget_metadata?.primary
                          ]
                        : "",
                  }
                : section_index >= 0
                ? panes[index]?.sections[section_index]?.widgets[widget_index]
                    ?.x_axis?.attribute ||
                  panes[index]?.sections[section_index]?.widgets[widget_index]
                    ?.primary
                  ? {
                      date_part: widget_metadata?.x_axis?.date_part,
                      special_cases:
                        widget_metadata?.x_axis?.special_cases ||
                        widget_metadata?.special_cases,
                      attribute: panes[index]?.sections[section_index]?.widgets[
                        widget_index
                      ]?.x_axis?.attribute
                        ? panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.x_axis?.attribute
                        : panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.primary,
                      value: d.data[0],
                      trace_name:
                        panes[index]?.sections[section_index]?.widgets[
                          widget_index
                        ]?.x_axis?.trace_name ||
                        allAttributes[
                          panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.x_axis?.attribute
                            ? panes[index]?.sections[section_index]?.widgets[
                                widget_index
                              ]?.x_axis?.attribute
                            : panes[index]?.sections[section_index]?.widgets[
                                widget_index
                              ]?.primary
                        ],
                    }
                  : undefined
                : panes[index]?.section[0]?.widgets[widget_index]?.x_axis
                    ?.attribute ||
                  panes[index]?.section[0]?.widgets[widget_index]?.primary
                ? {
                    attribute: panes[index]?.section[0]?.widgets[widget_index]
                      ?.x_axis?.attribute
                      ? panes[index]?.section[0]?.widgets[widget_index]?.x_axis
                          ?.attribute
                      : panes[index]?.section[0]?.widgets[widget_index]
                          ?.primary,
                    value: d.data[0],
                    trace_name:
                      panes[index]?.section[0]?.widgets[widget_index]?.x_axis
                        ?.trace_name ||
                      allAttributes[
                        panes[index]?.section[0]?.widgets[widget_index]?.x_axis
                          ?.attribute
                          ? panes[index]?.section[0]?.widgets[widget_index]
                              ?.x_axis?.attribute
                          : panes[index]?.section[0]?.widgets[widget_index]
                              ?.primary
                      ],
                  }
                : undefined,
            y_axis:
              (widget_metadata?.y_axes?.[0]?.attribute ||
                widget_metadata?.secondary) &&
              shareTemplateData
                ? {
                    date_part:
                      widget_metadata?.y_axes?.[0]?.date_part &&
                      widget_metadata?.y_axes?.[0]?.date_part !== "D"
                        ? widget_metadata?.y_axes?.[0]?.date_part
                        : widget_metadata?.y_axes?.[0]?.date_aggregation,
                    special_cases:
                      widget_metadata?.y_axes?.[0]?.special_cases ||
                      widget_metadata?.special_cases,
                    attribute: widget_metadata?.y_axes?.[0]?.attribute
                      ? widget_metadata?.y_axes?.[0]?.attribute
                      : widget_metadata?.secondary,
                    value: d?.data?.[4]?.[e?.target?.__data__?.data?.index],
                    trace_name:
                      widget_metadata?.y_axes?.[0]?.trace_name ||
                      allAttributes?.[
                        widget_metadata?.y_axes?.[0]?.attribute
                          ? widget_metadata?.y_axes?.[0]?.attribute
                          : widget_metadata?.secondary
                      ]
                        ? widget_metadata?.y_axes?.[0]?.trace_name ||
                          allAttributes?.[
                            widget_metadata?.y_axes?.[0]?.attribute
                              ? widget_metadata?.y_axes?.[0]?.attribute
                              : widget_metadata?.secondary
                          ]
                        : "",
                  }
                : section_index >= 0
                ? panes[index]?.sections[section_index]?.widgets[widget_index]
                    ?.y_axes ||
                  panes[index]?.sections[section_index]?.widgets[widget_index]
                    ?.secondary
                  ? {
                      date_part: widget_metadata?.y_axes
                        ? widget_metadata?.y_axes[0]?.date_part &&
                          widget_metadata?.y_axes[0]?.date_part !== "D"
                          ? widget_metadata?.y_axes[0]?.date_part
                          : widget_metadata?.y_axes[0]?.date_aggregation
                          ? widget_metadata?.y_axes[0]?.date_aggregation
                          : null
                        : null,
                      special_cases:
                        widget_metadata?.y_axes?.[0]?.special_cases ||
                        widget_metadata?.special_cases,
                      attribute: panes[index]?.sections[section_index]?.widgets[
                        widget_index
                      ]?.y_axes
                        ? panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.y_axes[0]?.attribute
                        : panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.secondary,
                      value: d?.data?.[4]?.[e?.target?.__data__?.data?.index],
                      trace_name:
                        panes[index]?.sections[section_index]?.widgets[
                          widget_index
                        ]?.y_axes[0]?.trace_name ||
                        allAttributes[
                          panes[index]?.sections[section_index]?.widgets[
                            widget_index
                          ]?.y_axes
                            ? panes[index]?.sections[section_index]?.widgets[
                                widget_index
                              ]?.y_axes[0]?.attribute
                            : panes[index]?.sections[section_index]?.widgets[
                                widget_index
                              ]?.secondary
                        ],
                    }
                  : undefined
                : panes[index]?.section[0]?.widgets[widget_index]?.y_axes ||
                  panes[index]?.section[0]?.widgets[widget_index]?.secondary
                ? {
                    attribute: panes[index]?.section[0]?.widgets[widget_index]
                      ?.y_axes
                      ? panes[index]?.section[0]?.widgets[widget_index]
                          ?.y_axes[0]?.attribute
                      : panes[index]?.section[0]?.widgets[widget_index]
                          ?.secondary,
                    value: d?.data?.[4]?.[e?.target?.__data__?.data?.index],
                    trace_name:
                      panes[index]?.section[0]?.widgets[widget_index]?.y_axes[0]
                        ?.trace_name ||
                      allAttributes[
                        panes[index]?.section[0]?.widgets[widget_index]?.y_axes
                          ? panes[index]?.section[0]?.widgets[widget_index]
                              ?.y_axes[0]?.attribute
                          : panes[index]?.section[0]?.widgets[widget_index]
                              ?.secondary
                      ],
                  }
                : undefined,
          },
          filters: filter ? filter : null,
          paneIndex: index,
          panes: panes,
          shareBrands: shareBrands,
          shareTemplateData: {
            ...shareTemplateData,
            isDeepDive: true,
            deep_dive: {
              infoBar: null,
              mentions: null,
              wordcloud: [],
              category: [],
              top_users: [],
              influencers: [],
              source_of_post: [],
              locations: [],
            },
          },
          tabName:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "Word Cloud"
              : "Mentions",
          shareCategory: shareCategory,
          filter_by: widget_metadata?.payload?.filter_by,
          filter_dropdown: widget_metadata?.payload?.filter_dropdown || [],
          filter_by_dropdown:
            widget_metadata?.payload?.filter_by_dropdown || [],
          public_engagement_only: public_engagement_only ? true : false,
        };
        graphObject.isSectionCompetitorBrandTypeExists = (() => {
          // Return false if any of these conditions are true
          if (
            widget_metadata?.duplicate_for_brands ||
            (shareBrands &&
              widget_metadata?.is_locked &&
              widget_brands?.columns) ||
            (shareBrands &&
              section_metadata?.is_locked &&
              section_brands?.columns) ||
            (!shareBrands &&
              widgets_is_locked &&
              (widget_metadata?.brand_ids || widget_metadata?.brand_groups)) ||
            (!shareBrands &&
              Section_is_locked &&
              (section_metadata?.brand_ids || section_metadata?.brand_groups))
          ) {
            return false;
          }

          // Return true only if sectionComprtitorBrandTypeExists is true and globalBrandChangeInShare is true
          return (
            (sectionComprtitorBrandTypeExists && globalBrandChangeInShare) ||
            false
          );
        })();
        !shareBrands && dispatch(setisDeepDive(true, panes, index));
        shareBrands &&
          dispatch(
            setShareSelectedDeepdiveWidget({
              section_index: section_index,
              widget_index: widget_index,
            })
          );

        dispatch(
          setIsDetailedInsightVisible({
            value: false,
            tab_id: null,
            name:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "Word Cloud"
                : "Mentions",
            key:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "2"
                : "1",
          })
        );

        dispatch(
          setTabClick({
            tabName:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "wordcloud"
                : "mentions",
            state: true,
          })
        );
        dispatch(setDeepDiveObject(graphObject));
        dispatch(setDeepDiveMentionsObject(graphObject));
        dispatch(setDeepDiveInfluencersObject(graphObject));
        shareTemplateData &&
          dispatch({
            type: "SET_SHARE_TEMPLATE_DATA",
            payload: {
              ...shareTemplateData,
              isDeepDive: true,
              deep_dive: {
                infoBar: null,
                mentions: null,
                wordcloud: [],
                category: [],
                top_users: [],
                influencers: [],
                source_of_post: [],
                locations: [],
              },
            },
          });

        dispatch(setMentionPageData({ data: null, page: 1, limit: 10 }));
        dispatch(set_WM_DeepDive(true));
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            graphObject,
            widget_ids,
            query?.get("share_id")
          )
        );
        dispatch(
          setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
        );
      } else if (e?.target?.__data__?.data?.index === undefined) {
      } else {
        const clickPosition = window?.innerWidth - e?.pageX;
        const clickPositionY = window?.innerHeight - e?.offsetY;
        const tName = d?.data[0];

        const headRef = headeRef?.current?.innerText;
        if (headRef?.toLowerCase()?.trim() !== tName?.toLowerCase()?.trim()) {
          tooltip?.select(`.newtooltip .tooltip-contentPie svg`)?.remove();
        }
        setTooltipPie(d);
        setTooltiphead(d.data[0]);
        setIsComponentVisible(true);
        //tooltip.select('.tooltip-heading').text(d.data[0]);
        tooltip
          ?.style(
            "top",
            `${
              e.offsetY < 90
                ? e.offsetY
                : clickPositionY < 220
                ? 150
                : e.offsetY - 50
            }px`
          )
          ?.style("left", `${clickPosition <= 230 ? 150 : e.offsetX}px`);
      }
    });
    points
      ?.transition()
      ?.delay(700)
      ?.ease(d3.easeExpInOut)
      ?.duration(1000)
      ?.style("opacity", 1)
      ?.attr("transform", (d) => {
        return `translate(${d?.x}, ${d?.y})`;
      });

    // Bubble text tooltip handlers
    function handleTextMouseOver(event, d) {
      // Calculate tooltip position at runtime based on mouse event
      setBubbleTextTooltip({
        visible: true,
        x: event.clientX,
        y: event.clientY,
        text:
          typeof d?.data[0] === "string" ? d?.data[0] : d?.data[0]?.toString(),
      });
    }
    function handleTextMouseMove(event, d) {
      // Update tooltip position at runtime
      setBubbleTextTooltip((prev) => ({
        ...prev,
        x: event.clientX,
        y: event.clientY,
      }));
    }
    function handleTextMouseOut(event, d) {
      setBubbleTextTooltip((prev) => ({ ...prev, visible: false }));
    }

    // Helper function: show each word on a separate tspan, last tspan gets ellipsis if overflow (>30 chars)
    function wrapBubbleText(text, radius, fontSize = 12, maxLines = 2) {
      if (text.length <= 30) return text.split(/\s+/);
      const charsPerLine = Math.max(20, Math.floor((radius * 1.7) / fontSize));
      let words = text.split(/\s+/);
      let lines = [];
      let charCount = 0;
      for (let i = 0; i < words.length; i++) {
        let word = words[i];
        charCount += word.length + 1; // +1 for space
        if (lines.length < maxLines - 1) {
          lines.push(word);
        } else {
          // Last tspan: add ellipsis if overflow
          let remaining = words.slice(i).join(" ");
          if (remaining.length > charsPerLine) {
            lines.push(remaining.substring(0, charsPerLine - 3) + "...");
          } else {
            lines.push(remaining);
          }
          break;
        }
      }
      return lines;
    }

    // Attach tooltip events to the parent text, not tspan
    points
      ?.append("text")
      .on("mouseover", handleTextMouseOver)
      .on("mousemove", handleTextMouseMove)
      .on("mouseout", handleTextMouseOut)
      ?.selectAll("tspan")
      ?.data(function (d) {
        const rawText =
          typeof d?.data?.[0] === "string"
            ? d?.data?.[0]
            : d?.data?.[0]?.toString();
        // Show each word on a separate tspan, last tspan gets ellipsis if overflow
        return wrapBubbleText(rawText, d.r, 12, 2);
      })
      ?.join("tspan")
      //.style('text-shadow' , '0 0 5px #000')
      ?.attr("x", 0)
      ?.attr("y", (d, i, nodes) => `${i - nodes?.length / 2 + 0.8}em`)
      ?.text((d) => d);

    points
      ?.append("text")
      ?.selectAll("tspan")
      ?.data((d) => {
        return d?.data[2];
      })
      ?.join("tspan")
      //.style('text-shadow' , '0 0 5px #000')
      ?.attr("x", 0)
      ?.attr("y", (d, i, nodes) => `${i - nodes?.length / 2 - 1}em`)
      ?.text((d) => kFormatter(d));

    // points.append("text")
    //       .style("text-anchor", "middle")
    //       .style("font-size", d => {  return (`${d.r/9}`) })
    //       .style("font-family", "Roboto")
    //       .style("fill", "#3B5175")
    //       .style('cursor' , 'pointer')
    //       //.style('text-shadow' , '0 0 5px #000')
    //       .attr('x', '0')
    //       .attr('y', (d, i, nodes) => `${i - nodes.length + 0.8}`)
    //       .text(d => { return(`(${d.data[1]})`)});
  };
  const tooltip = d3?.select(
    `#newtooltip__${uniqueId?.replaceAll(/[^a-zA-Z0-9]/g, "")}`
  );
  const createTooltippie = async () => {
    //let pieSum = d3.sum(tooltipPie?.pie); //sum of all the pie arc values
    let arcEntertooltip = tooltip
      ?.select(".tooltip-contentPie")
      ?.selectAll("g")
      ?.data(tooltipPie)
      ?.enter()
      ?.append("svg")
      ?.attr("width", "200")
      ?.attr("height", "190")
      ?.attr("class", "node")
      ?.append("g")
      ?.attr("transform", `translate(100, 100)`);

    let pies = arcEntertooltip?.selectAll(".node")?.data((d) => {
      return arcGenerator(d?.data[1])?.map((m, i) => {
        m.r = 168;
        m.x = d?.x;
        m.y = d?.y;
        let obj = {
          data: m,
          color: d?.data[3][i],
          name: d?.data[4][i],
          total: d?.value,
        };
        return obj;
      });
    });

    var newarcEnter = pies?.enter()?.append("g")?.attr("class", "node");
    newarcEnter
      ?.append("path")
      ?.attr("d", function (d) {
        arc?.outerRadius(d?.data.r / 2);
        return arc(d?.data);
      })
      // .on("click", (e, d) => onBubbleClick(d))
      ?.attr("fill", function (d) {
        return d?.color;
      });
    newarcEnter
      ?.append("text")
      ?.attr("transform", function (d) {
        let percent = (d?.data?.value / d?.total) * 100;
        if (percent < 6) {
          var c = arc?.centroid(d?.data),
            x = c[0],
            y = c[1],
            // pythagorean theorem for hypotenuse
            h = Math.sqrt(x * x + y * y);
          return `translate(${(x / h) * 90}, ${(y / h) * 90})`;
        } else {
          return "translate(" + arc?.centroid(d?.data) + ")";
        }
      })
      ?.style("text-anchor", "middle")
      ?.style("font-size", "0.7em")
      ?.style("fill", function (d) {
        let percent = (d?.data?.value / d?.total) * 100;
        if (percent < 6) {
          return "#3b5175";
        } else {
          return "#eee";
        }
      })
      //.on("click", (e, d) => onBubbleClick(d))
      ?.text((d) => {
        return `${((d?.data?.value / d?.total) * 100)?.toFixed(0)}%`;
      });
    //tooltip.select('.tooltip-content').text(tooltipPie.data[1]);
    tooltip
      ?.select(".tooltip-content")
      ?.text(kFormatter(tooltipPie?.data[2][0]));
  };
  useEffect(() => {
    tooltipPie && createTooltippie();
  }, [tooltipPie]);

  // const adaptLabelFontSize = (d) => {
  //   var xPadding, diameter, labelAvailableWidth, labelWidth;

  //   xPadding = 8;
  //   diameter = 2 * d?.r;
  //   labelAvailableWidth = diameter - xPadding;

  //   labelWidth = this?.getComputedTextLength();

  //   // There is enough space for the label so leave it as is.
  //   if (labelWidth < labelAvailableWidth) {
  //     return null;
  //   }
  //   return labelAvailableWidth / labelWidth + "px";
  // };

  const useComponentVisible = (initialIsVisible) => {
    const [isComponentVisible, setIsComponentVisible] =
      useState(initialIsVisible);
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
      if (event?.key === "Escape") {
        setIsComponentVisible(false);
      }
    };

    const handleClickOutside = (event) => {
      if (ref?.current && !ref?.current?.contains(event?.target)) {
        setIsComponentVisible(false);
      }
    };

    useEffect(() => {
      document?.addEventListener("keydown", handleHideDropdown, true);
      document?.addEventListener("click", handleClickOutside, true);
      return () => {
        document?.removeEventListener("keydown", handleHideDropdown, true);
        document?.removeEventListener("click", handleClickOutside, true);
        // window?.removeEventListener("resize", createBubbleChart, true);
      };
    });

    return { ref, isComponentVisible, setIsComponentVisible };
  };

  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  return (
    <div className="position-relative" ref={mainDivRef}>
      <div
        ref={ref}
        style={{
          width: width,
          height: height,
          margin: legend_position !== "bottom" ? "0 auto 1.5rem" : "0 auto",
          paddingTop: legend_position === "top" ? "2.1rem" : "0",
        }}
      >
        <svg
          style={{ width: "100%", height: height }}
          id={`bubblechart__${uniqueId?.replaceAll(/[^a-zA-Z0-9]/g, "")}`}
          className="bubblechart"
          //onClick={() => setIsComponentVisible(true)}
          ref={DivRef}
          //viewBox={`0 0 ${width} ${height}`}
          //perserveAspectRatio="xMidYMid meet"
          perserveaspectratio="xMidYMid meet"
          svg-content={"true"}
        />
        <div
          id={`newtooltip__${uniqueId?.replaceAll(/[^a-zA-Z0-9]/g, "")}`}
          className="newtooltip"
          style={{
            opacity: isComponentVisible === true ? "1" : "0",
            zIndex: isComponentVisible === true ? "1" : "-1",
          }}
        >
          <div className="d-flex justify-content-between pr-4">
            {/* <Tooltip
              title={tooltiphead}
              placement="topLeft"
              className="text-ellipsis d-block"
            >
              <a className="tooltip-heading text-ellipsis" ref={headeRef}>
                {tooltiphead}
              </a>
            </Tooltip> */}
            {tooltiphead?.length > 20 ? (
              <Tooltip
                title={tooltiphead}
                placement="topLeft"
                className="text-ellipsis d-block"
              >
                <div className="tooltip-heading text-ellipsis" ref={headeRef}>
                  {tooltiphead}
                </div>
              </Tooltip>
            ) : (
              <div className="tooltip-heading text-ellipsis" ref={headeRef}>
                {tooltiphead}
              </div>
            )}

            <i
              className="fa fa-times attr_close"
              onClick={() => setIsComponentVisible(false)}
            />
          </div>
          <div className="tooltip-contentPie" />
          <div className="tooltip-content" />
        </div>
        {/* Tooltip for bubble text */}
        {bubbleTextTooltip.visible && (
          <div
            style={{
              position: "fixed",
              left: bubbleTextTooltip.x + 10,
              top: bubbleTextTooltip.y + 10,
              background: "var(--locobuzz-primary-bg-color)",
              border: "1px solid  var(--locobuzz-border-color)",
              borderRadius: "4px",
              padding: "8px 12px",
              pointerEvents: "none",
              zIndex: 9999,
              boxShadow: "var(--locobuzz-box-shadow-medium)",
              minWidth: "120px",
              color: "var(--locobuzz-primary-text-color)",
              fontWeight: "bold",
            }}
          >
            {bubbleTextTooltip.text}
          </div>
        )}
      </div>
      <div className={`tooltip-legend ${legend_position}`}>
        {legend &&
          show_legend &&
          legend?.map((e, i) => {
            return (
              <span
                key={`legend_${i}`}
                className="d-inline-flex align-items-center line-height-normal"
              >
                <span
                  className="color-legend"
                  style={{ backgroundColor: `${e?.color}` }}
                ></span>
                {e?.legend?.length > 28 ? (
                  <Tooltip title={e?.legend}>
                    <span
                      style={{ maxWidth: "20rem" }}
                      className="text-ellipsis d-inline-block"
                    >
                      {e?.legend}
                    </span>
                  </Tooltip>
                ) : (
                  <span
                    style={{ maxWidth: "20rem" }}
                    className="text-ellipsis d-inline-block"
                  >
                    {e?.legend}
                  </span>
                )}
              </span>
            );
          })}
      </div>
    </div>
  );
};
export default BubbleChart;
